import { useEffect, useState } from 'react';

import get from 'lodash/get';
import useSWR from 'swr';

import { getStorageClasses } from '../api';
import type { StorageClassOptionItem } from '../types';
import { mapStorageClassItems } from '../utils';

const SWR_KEY = { key: 'STORAGE_CLASS_OPTIONS', limit: -1 };

export function useStorageClassOptions(enabled = false, filterProvisioner?: string) {
  const { data, isLoading } = useSWR(enabled ? SWR_KEY : null, () => getStorageClasses({ limit: -1 }), {
    revalidateOnFocus: false,
  });
  const [options, setOptions] = useState<StorageClassOptionItem[]>([]);

  useEffect(() => {
    if (data) {
      setOptions(mapStorageClassItems(get(data, 'items', []), filterProvisioner));
    }
  }, [data, filterProvisioner]);

  return { options, isLoading };
}
